interface ContactData {
  id: string;
  phone: string;
  email: string;
  adress: string; // matches backend
  vat: string; // matches backend
  mapsUrl: string;
}

/**
 * POST — Add new contact info
 */
export async function postContactInfo(contactData: ContactData) {
  const response = await fetch(`/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(contactData),
  });

  if (!response.ok) {
    throw new Error(`Error adding contact info: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
}
